import React, { useEffect, useMemo, useState } from "react";

// Simple controlled color picker with hex input + native color input + Select button
// Props: value (#rrggbb), onChange(hex)
const ColorPicker = ({
  label = "Background Color",
  value = "#ffffff",
  onChange,
  disabled = false,
}) => {
  const [hex, setHex] = useState(value || "#ffffff");

  useEffect(() => {
    if (typeof value !== "string") return;
    setHex((prev) =>
      value.toLowerCase() === (prev || "").toLowerCase() ? prev : value,
    );
  }, [value]);

  const isValidHex = useMemo(() => /^#?[0-9a-fA-F]{6}$/.test(hex || ""), [hex]);
  const normalized = useMemo(
    () => (hex?.startsWith("#") ? hex : `#${hex}`),
    [hex],
  );

  const commit = () => {
    if (!isValidHex) return;
    onChange?.(normalized.toLowerCase());
  };

  return (
    <div className="form-group">
      {label && <label>{label}</label>}
      <div
        style={{
          display: "flex",
          gap: 8,
          alignItems: "center",
          flexWrap: "nowrap",
        }}
      >
        <input
          className="input"
          style={{ flex: 1 }}
          value={hex}
          onChange={(e) => setHex(e.target.value.trim())}
          placeholder="#ffffff or ffffff"
          disabled={disabled}
        />
        {!disabled && (
          <>
            <input
              type="color"
              value={normalized}
              onChange={(e) => {
                setHex(e.target.value);
                onChange?.(e.target.value);
              }}
              title="Pick color"
              style={{
                width: 44,
                height: 32,
                padding: 0,
                border: "1px solid #cbd5e1",
                borderRadius: 6,
              }}
            />
            <button
              type="button"
              className="secondary-btn"
              onClick={commit}
              disabled={!isValidHex}
              style={{ whiteSpace: "nowrap" }}
            >
              Select
            </button>
          </>
        )}
      </div>
      {!isValidHex && (
        <div
          className="input-hint"
          style={{ color: "#b91c1c", fontSize: 12, marginTop: 4 }}
        >
          Enter a valid 6-digit hex color (e.g., #ffaa00)
        </div>
      )}
    </div>
  );
};

export default ColorPicker;
